module.exports = __webpack_public_path__ + "img/video_3.1a1a1997.png";